import { ButtonInputWithPopover } from "@msys/ui";
import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup,
  Typography,
} from "@mui/material";
import { useTranslate } from "@tolgee/react";
import { ProjectFilterKind } from "../../../../clients/graphqlTypes.js";
import {
  FilterChipGroup,
  FilterChipGroupProps,
} from "../../../commons/filters/FilterChip.js";
import { FilterProps } from "../../../commons/filters/index.js";
import { useProjectKinds } from "../useProjectKinds.js";

export function ProjectKindsFilterButton(
  props: FilterProps<ProjectFilterKind[]>
) {
  const { t } = useTranslate("ProjectTypes");
  const { projectKindOptions } = useProjectKinds();

  return (
    <ButtonInputWithPopover
      label={t("Size")}
      counter={
        props.value &&
        props.value.length > 0 &&
        props.value.length < projectKindOptions.length
          ? props.value.length
          : undefined
      }
      content={<ProjectKindsFilterForm {...props} />}
      popoverWidth="md"
    />
  );
}

function ProjectKindsFilterForm({
  value,
  setValue,
}: FilterProps<ProjectFilterKind[]>) {
  const { projectKindOptions } = useProjectKinds();

  return (
    <Box p={1}>
      <FormControl component="fieldset" variant="standard">
        <FormGroup>
          {projectKindOptions.map((option, index) => (
            <FormControlLabel
              control={
                <Checkbox
                  size="medium"
                  checked={value.includes(option.value)}
                  onChange={(_event, checked) => {
                    if (checked) {
                      setValue(Array.from(new Set([...value, option.value])));
                    } else {
                      setValue(value.filter(v => v !== option.value));
                    }
                  }}
                />
              }
              label={<Typography variant="body1">{option.label}</Typography>}
              sx={{ ml: 0, mr: 0 }}
              key={`${option.value}-${index}`}
            />
          ))}
        </FormGroup>
      </FormControl>
    </Box>
  );
}

export function ProjectKindsFilterChips(
  props: Omit<
    FilterChipGroupProps<ProjectFilterKind>,
    "label" | "getValueLabel"
  >
) {
  const { t } = useTranslate("ProjectTypes");
  const { projectKindLabels } = useProjectKinds();

  return (
    <FilterChipGroup
      label={t("Size")}
      setValues={props.setValues}
      values={props.values}
      getValueLabel={value => projectKindLabels[value]}
    />
  );
}
